import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

/**
 * Shown when the browser reports offline. Renders nothing when online — no
 * layout shift when connectivity flaps. Copy is deliberately short: the
 * service worker serves cached data in the background, so users can keep
 * reading even if writes are blocked.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900 text-xs px-4 py-2 flex items-center gap-2">
      <WifiOff size={14} />
      <span>
        You're offline — showing cached data. Changes will save once you're back on the network.
      </span>
    </div>
  );
}
